import { TabButton } from '../../../../../pages/ContractScreensView/components/TabButton';
import SpinnerLoader from '../../../../SpinnerLoader/SpinnerLoader';
import { NO_TAB_SELECTED } from '../../constants';
import { CycleChartDataTabsInteractorProps, useCycleChartDataTabsInteractor } from './interactor';
import { TabsRouter } from './router';

export const ChartDataTabs = (props: CycleChartDataTabsInteractorProps) => {
  const { onChangeTab, activeTab, staticTabNumber, liveTabNumber, isLoading, isCompleted } =
    useCycleChartDataTabsInteractor(props);

  const onClickStaticHandler = () => {
    onChangeTab(staticTabNumber);
  };

  const onClickActiveHandler = () => {
    onChangeTab(liveTabNumber);
  };

  if (isLoading) {
    return (
      <div className="align-center flex h-full w-full items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (activeTab === NO_TAB_SELECTED) {
    return (
      <div className="mx-auto flex max-w-md flex-col items-center mt-30 gap-2 rounded-xl bg-white p-5 text-center font-satoshi shadow">
        <div className="text-2xl">💡</div>
        <div>
          <p className="mb-1 text-title-xsm font-medium">The cycle is currently inactive.</p>
          <p className="text-title-xsm font-medium">Please activate it to continue.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {!isCompleted && (
        <div className={'gird grid auto-cols-fr grid-flow-col gap-x-3 pb-4'}>
          <TabButton text={'Static'} onClick={onClickStaticHandler} isActive={activeTab === staticTabNumber} />
          <TabButton
            text={
              <span className="flex items-center justify-center gap-x-2">
                Live
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-red"></span>
                </span>
              </span>
            }
            onClick={onClickActiveHandler}
            isActive={activeTab === liveTabNumber}
          />
        </div>
      )}

      <TabsRouter active={activeTab} />
    </>
  );
};
